export default __webpack_public_path__ + "static/media/be-a-sponsor.dc2e6b5e.png";